// extracted by mini-css-extract-plugin
export default {"gallery":"CardGallery_gallery__zIt7w","small":"CardGallery_small__BAxff","active":"CardGallery_active__npOlh","big":"CardGallery_big__E6fm1"};